import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

interface MyYearPickerProps {
  onChange?: (date: Date) => void;
  value?: Date;
}

const MyYearPicker: React.FC<MyYearPickerProps> = ({ onChange, value }) => {
  return (
    <DatePicker
      calendar={persian}
      locale={persian_fa}
      onlyYearPicker // ✅ Only shows years
      format="YYYY"
      calendarPosition="bottom-right"
      value={value}
      onChange={(date) => {
        if (onChange) {
          const gregorianDate = date?.toDate?.(); // convert to JS Date
          if (gregorianDate) onChange(gregorianDate);
        }
      }}
      style={{
        height: 35,
        width: 60,
        textAlign: "center",
        borderRadius: 6,
        fontSize: 14,
        cursor: "pointer", // ✅ Added this line
      }}
      
    />
  );
};

export default MyYearPicker;
